<div fxLayout="column" fxLayoutAlign="center center">
  <div class="content">
    <p>
      In order to protect your identity, we'll need to confirm who you are. To
      access the form, either enter the six digit code we sent to
      <span class="style-bold">{{ email }}</span
      >, or click on the link in that email.
    </p>
    @if (!expired) {
      <div fxLayout="column" class="code-input-container">
        <ng-otp-input
          [config]="config"
          (onInputChange)="handleCodeChange($event)"
          #ngOtpInput
        >
        </ng-otp-input>
      </div>
    }
    @if (!expired) {
      <div>
        <p>Didn't receive an email?</p>
        <button mat-flat-button color="primary" (click)="requestCode()">
          Request New Code
        </button>
      </div>
    }
    @if (errorMessage) {
      <div class="error-message">{{ errorMessage }}</div>
    }
  </div>
</div>
